import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Button, notification } from 'antd';
import { useHistory } from 'react-router-dom';
import { submitGalleryCreate, submitGalleryEdit } from '../../utils';

const openNotification = () => {
  notification.error({
    message: 'Error!',
    description:
      'There was an error submitting. Double check to make sure there are no mistakes.',
  });
};

const SubmitButton = (props) => {
  const state = useSelector((state) => state.editGallery); // for retrieving state
  const dispatch = useDispatch(); // for changing state
  const history = useHistory();

  const submitGallery = () => {
    props.onSubmit();
    
    const related_links = state.gallery.flatMap((item, index) => {
      const itemLinks = Array.isArray(item.related_links) ? item.related_links : [];
      const id = item.metatype === "image" ? item.url : item.id;
      return itemLinks
        .filter(link => (link.url && link.url.trim()) || (link.text && link.text.trim()))
        .map(link => ({
          id: id,
          url: link.url || "",
          text: link.text || "",
          index: index,
        }));
    });
    
    const successCallback = () => {
      dispatch({
        type: 'DELETE_GALLERY',
      });
      history.push('/');
    };
    const failureCallback = () => {
      openNotification();
    };
    if (props.id) {
      submitGalleryEdit(
        props.id,
        state.name,
        state.layout,
        state.description,
        state.gallery,
        state.correction,
        related_links,
        successCallback,
        failureCallback
      );
    } else {
      submitGalleryCreate(
        state.name,
        state.layout,
        state.description,
        state.gallery,
        state.correction,
        related_links,
        successCallback,
        failureCallback
      );
    }
    //do other stuff after
    // console.log('success', success);
    // success.then((value) => {
    //   console.log(value);
    //   if (value) {
    //   } else openNotification();
    // });
  };
  return (
    <Button type="primary" onClick={() => submitGallery()}>
      Submit
    </Button>
  );
};

export default SubmitButton;
